import { render, staticRenderFns } from "./dr-content-header.vue?vue&type=template&id=10a5e722&"
import script from "./dr-content-header.vue?vue&type=script&lang=js&"
export * from "./dr-content-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports